import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoMdSearch } from "react-icons/io";
import { MdEdit } from "react-icons/md";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useDeleteGroupMutation, useGetAllGroupsQuery } from "./groupApislice";
import AreYouSureModal from "../reduxworkbook/components/WorkbookComponets/AreYouSureModal";
import { useMyContext } from "../../MyContext";
import { HiOutlineRefresh } from "react-icons/hi";

export default function CreateGroupPage() {
  const navigate = useNavigate();
  const { setToast } = useMyContext();
  const [
    deleteGroup,
    {
      data: deletedGroupData,
      isLoading: isDeleteGroupLoading,
      isError: isDeleteGroupError,
      isSuccess: isDeleteGroupSuccess,
      error: deletedGroupError,
    },
  ] = useDeleteGroupMutation();
  const {
    data: groups = [],
    isLoading,
    isError,
    isSuccess,
    error,
    refetch,
  } = useGetAllGroupsQuery();
  // console.log(groups);

  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [groupToDelete, setGroupToDelete] = useState(null);

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const openDeleteModal = (groupId) => {
    setGroupToDelete(groupId);
    setShowModal(true);
  };

  const closeDeleteModal = () => {
    setShowModal(false);
    setGroupToDelete(null);
  };

  const handleDeleteGroup = async () => {
    if (groupToDelete) {
      deleteGroup({ groupId: groupToDelete });
      setShowModal(false);
    }
  };
  // Filter groups based on search term
  const filteredGroups = groups.filter((group) =>
    group.groupName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    if (isDeleteGroupError && deletedGroupError) {
      const errorMessage =
        deletedGroupError?.data?.message ||
        deletedGroupError?.data?.error ||
        "an error while deleting the group";
      console.error(errorMessage);
      setToast({ message: errorMessage, status: "error" });
    }
    if (isDeleteGroupSuccess && deletedGroupData) {
      refetch();
      console.log(deletedGroupData?.message || "Group deleted successfully");
      const successMessage =
        deletedGroupData?.message || "Group deleted successfully";
      setToast({ message: successMessage, status: "success" });
    }
  }, [isDeleteGroupError, isDeleteGroupSuccess]);
  return (
    <div className="overflow-hidden flex flex-col w-full h-[94vh] min-h-[94vh]">
      <section className="flex items-center justify-between px-[8px] py-[6px] border-y border-gray-400 h-auto text-xs">
        <div className="w-2/3 flex items-center justify-start gap-2 font-medium text-sm">
          Group List
          <div className="flex justify-start items-center rounded border border-gray-300 text-gray-800 shadow gap-1 px-1 py-[1px] h-full w-auto">
            <IoMdSearch className="text-gray-400" />
            <input
              className="w-[16rem] placeholder:text-[12px] pb-[4px] focus:outline-none text-sm"
              type="text"
              placeholder="Search groups..."
              value={searchTerm}
              onChange={handleInputChange}
            />
          </div>
        </div>
        <div className="flex items-center justify-center gap-4">
          <button
            className="flex items-center justify-center gap-2 border border-gray-950 rounded px-5 py-1 bg-gray-950 text-white truncate"
            onClick={() => refetch()}
          >
            Refetch <HiOutlineRefresh className="text-sm" />
          </button>
          <button
            className="border border-blue-950 rounded px-5 py-1 bg-blue-950 text-white truncate"
            onClick={() => navigate("/home/dash/creategroup")}
          >
            Create Group
          </button>
        </div>
      </section>

      <section className="flex flex-col gap-1 h-[94%] border-gray-300 border pt-2">
        <div className="overflow-y-auto h-full">
          {isLoading ? (
            <div className="p-4">Loading...</div>
          ) : isError ? (
            <div className="p-4 text-red-500">Error: {error?.message}</div>
          ) : (
            <table className="border-none w-full">
              <thead className="sticky top-0 bg-white z-10">
                <tr>
                  <th className="border-b text-left px-2">Group Name</th>
                  <th className="border-b text-left px-2">Number of Users</th>
                  <th className="border-b text-left px-2">Edit</th>
                  <th className="border-b text-left px-2">Delete</th>
                </tr>
              </thead>
              <tbody>
                {filteredGroups.map((group, groupIndex) => {
                  const isEven = groupIndex % 2 === 0;
                  // console.log(group);

                  return (
                    <tr
                      key={groupIndex}
                      className={isEven ? "bg-gray-100" : "bg-white"}
                    >
                      <td className="border-b text-left px-2 py-1">
                        {group.groupName}
                      </td>

                      <td className="border-b text-left px-2 py-1">
                        {group.memberCount}
                      </td>

                      <td className="border-b text-left px-2 py-1">
                        {/* Edit icon */}
                        <button
                          onClick={() =>
                            navigate(
                              `/home/dash/updategroup?groupid=${group._id}`
                            )
                          }
                        >
                          <MdEdit className="text-gray-600 cursor-pointer" />
                        </button>
                      </td>
                      <td className="border-b text-left px-2 py-1">
                        {/* Delete icon */}
                        <button onClick={() => openDeleteModal(group._id)}>
                          <RiDeleteBin6Line className="text-gray-600 cursor-pointer" />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </section>

      {/* Confirmation Modal */}
      {showModal ? (
        <AreYouSureModal
          message={"Are you sure that you want delete this data source"}
          closeModal={closeDeleteModal}
          okayButton={handleDeleteGroup}
        />
      ) : null}
    </div>
  );
}
